import React, { Component } from "react";
import { Dialog } from 'primereact/dialog';
import { I18n } from "react-redux-i18n";
import auth, { _log, get } from "../js/auth";
import Chat from "./Chat";

const rocketApiBase = "https://chat.eatwithme.online/api/v1";

class ChatModal extends Component {

    // Fetch unread count for the default room using groups.counters
    fetchUnreadCount = (callback) => {
        if (!this.state.roomId) {
            this.fetchRoomId((roomId) => {
                if (roomId) {
                    this.fetchUnreadCount(callback);
                } else {
                    if (callback) callback(0);
                }
            });
            return;
        }
        get(`${rocketApiBase}/groups.counters?roomId=${this.state.roomId}`, undefined, {
            "X-Auth-Token": this.state.token,
            "X-User-Id": this.state.id,
            "Content-Type": "application/json"
        }, undefined, undefined, false)
            .done(counters => {
                // counters.unreadMessages holds the unread count
                const unreadCount = counters.unreads || 0;
                if (callback) callback(unreadCount);
            })
            .fail(() => {
                if (callback) callback(0);
            });
    }
    constructor(props) {
        super(props);
        if (props.forwardedRef) {
            props.forwardedRef.current = {
                open: this.open,
                close: this.close,
            };
        }
    }

    state = {
        visible: false,
        token: null,
        unreadCount: 0,
        unreadInterval: null,
        roomId: null
    };

    componentWillUnmount = () => {
        if (this.unreadInterval) {
            clearInterval(this.unreadInterval);
        }
    }


    fetchRoomId = (callback) => {
        if (this.state.roomId) {
            if (callback) callback(this.state.roomId);
            return;
        }
        if (!this.props.myStatus || !this.props.myStatus.restaurant_name || !this.props.myStatus.restaurant_global_id || !this.state.token || !this.state.id) {
            if (callback) callback(null);
            return;
        }
        if (this.state.roomId) {
            if (this.state.roomId !== "error" && callback) callback(this.state.roomId);
            return;
        }
        const roomName = (this.props.myStatus.restaurant_name.normalize("NFD").replace(/[^a-zA-Z0-9 _.-]/g, "").replace(/\s+/g, "-") + "-" + this.props.myStatus.restaurant_global_id).replace(/--/g, "-");
        get(`${rocketApiBase}/groups.info?roomName=${roomName}`, undefined, {
            "X-Auth-Token": this.state.token,
            "X-User-Id": this.state.id,
            "Content-Type": "application/json"
        }, undefined, undefined, false)
            .done(data => {
                if (data.group && data.group._id) {
                    this.setState({ roomId: data.group._id }, () => {
                        if (callback) callback(data.group._id);
                    });
                } else {
                    if (callback) callback(null);
                }
            })
            .fail(() => {
                this.setState({ roomId: "error", token: null }, () => {
                    this.initialize();
                });
                //if (callback) callback();
            });
    }

    pollUnreadCount = () => {
        this.fetchUnreadCount((count) => {
            this.setState({ unreadCount: count });
        });
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps, prevState) {
        this.initialize();
    }


    initialize = (handler) => {
        if (!this.state.token && !this.loginInProgress) {
            this.loginInProgress = true;
            get("https://instance.eatwithme.online/eatwithme.server/rocket/login", undefined, undefined, undefined, false).done(res => {
                if (res.authToken) {
                    this.setState({ token: res.authToken, id: res.userId }, () => {
                        this.loginInProgress = false;
                        if (this.fetchingRoomId) return;
                        this.fetchingRoomId = true;
                        this.fetchRoomId(() => {
                            this.fetchingRoomId = false;
                            if (this.unreadInterval) clearInterval(this.unreadInterval);
                            this.unreadInterval = setInterval(this.pollUnreadCount, 380000);
                        });
                        handler && handler();
                    });
                }
            }).fail(() => {
                this.loginInProgress = false;
                auth.ajaxError = false;
                this.setState({ token: "error" });
            });
        }
        handler && handler();
        if (this.state.token && !this.fetchingRoomId && this.state.roomId === null) {
            this.fetchingRoomId = true;
            this.fetchRoomId(() => {
                this.fetchingRoomId = false;
                if (this.unreadInterval) clearInterval(this.unreadInterval);
                this.unreadInterval = setInterval(this.pollUnreadCount, 380000);
            });
        }
    }

    open = () => {
        _log("ChatModal open called");
        get(`${rocketApiBase}/groups.counters?roomId=${this.state.roomId}`, undefined, {
            "X-Auth-Token": this.state.token,
            "X-User-Id": this.state.id,
            "Content-Type": "application/json"
        }, undefined, undefined, false)
            .done(counters => {
                this.setState({ visible: true });
            })
            .fail(() => {
                this.setState({ token: null, roomId: null }, () => {
                    this.initialize(() => {
                        this.setState({ visible: true });
                    });
                });
            });
    };

    close = () => {
        this.setState({ visible: false });
    };

    render() {
        if (!this.props.myStatus || !this.props.myStatus.restaurant_id) {
            return null;
        }

        return (
            <>
                <button
                    type="button"
                    className="p-button"
                    style={{
                        marginRight: 8,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 36,
                        height: 36,
                        padding: 0,
                        background: 'transparent',
                        boxShadow: 'none',
                        border: 'none',
                        color: 'inherit',
                        position: 'relative'
                    }}
                    onClick={this.open}
                    title={I18n.t("admin_local.menus.chat_with_support")}
                >
                    <i className="pi pi-comments" style={{ fontSize: '1.5em', color: 'inherit' }}></i>
                    {this.state.unreadCount > 0 && (
                        <span style={{
                            position: 'absolute',
                            top: 2,
                            right: 2,
                            background: '#e53935',
                            color: 'white',
                            borderRadius: '50%',
                            minWidth: 18,
                            height: 18,
                            fontSize: '0.9em',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0 5px',
                            zIndex: 2
                        }}>{this.state.unreadCount}</span>
                    )}
                </button>

                <Dialog
                    header={I18n.t("admin_local.menus.chat_with_support")}
                    visible={this.state.visible}
                    style={{ width: '90vw', height: '90vh' }}
                    modal
                    onHide={this.close}
                    maximizable
                >
                    <div style={{ display: "flex", flexFlow: "column", height: "100%" }}>
                        <Chat token={this.state.token} id={this.state.id} {...this.props} />
                    </div>
                </Dialog>

            </>
        );
    }
}

export default ChatModal;
